<template>
	<div class>
		<v-card class="elevation-3 pa-1 mb-6">
			<v-sheet>
				<component :is="this.context ? context : 'div'">{{ !this.context ? 'Select Tool' : '' }}</component>
			</v-sheet>
		</v-card>
	</div>
</template>

<script>
// import moment from "moment";
import { bus } from '@/main';
import LocumSearchTool from '@/components/ui/dashboard/admin/cards/LocumSearchTool.vue';
import PracticeSearchTool from '@/components/ui/dashboard/admin/cards/PracticeSearchTool.vue';
import ViewLocumProfile from '@/components/ui/dashboard/admin/cards/ViewLocumProfile.vue';
import ViewPracticeProfile from '@/components/ui/dashboard/admin/cards/ViewPracticeProfile.vue';

// import axios from "axios"; //be able to make requests.
// import store from "@/store"; //expose the vuex store, jwt token and user.

/* eslint-disable  */
/* eslint-enable  */

export default {
	name: 'AdminDashboardBigCalendar',
	components: { LocumSearchTool, PracticeSearchTool, ViewLocumProfile, ViewPracticeProfile },
	data: () => ({
		//
		context: null,
	}),
	computed: {
		//
		/* eslint-disable-next-line vue/return-in-computed-property */
	},

	created() {
		bus.$on('change-main-context', new_context => {
			this.context = new_context;
		});
	},

	mounted() {},

	methods: {},
};
</script>

<style scoped></style>
